import { Appearance, StripePaymentElementOptions } from '@stripe/stripe-js'
import { l } from '@manychat/manyui'

import { CheckoutTypes } from 'common/billing/constants/checkoutTypes'

export const STRIPE_CHECKOUT_POST_UPGRADE_MESSAGES = {
  [CheckoutTypes.UPGRADE_DATA]: l.translate('Billing Credentials were updated successfully'),
  [CheckoutTypes.TRIAL]: l.translate('Trial activated!'),
  [CheckoutTypes.UPGRADE_TO_PRO]: l.translate('Payment was successful'),
}

export const stripeElementsAppearance: Appearance = {
  theme: 'stripe',
  variables: {
    fontFamily: 'InterVariable, Helvetica, Arial, sans-serif',
    colorDanger: '#eb5038',
    colorDangerText: '#eb5038',
  },
  rules: {
    '.Label': {
      fontSize: '15px',
      fontWeight: '600',
      paddingBottom: '6px',
    },
    '.Input': {
      borderRadius: '6px',
      padding: '7px 12px',
      boxShadow: 'none',
      lineHeight: '20px',
      border: '1px solid #e1e5ea',
    },
    '.Input:focus': {
      borderColor: '#0084ff',
      boxShadow: 'none',
    },
    '.Input:hover': {
      borderColor: '#8592a3',
    },
    '.Input--invalid': {
      boxShadow: 'none',
      color: 'inherit',
    },
  },
}

export const defaultPaymentElementOptions: StripePaymentElementOptions = {
  terms: {
    card: 'never',
  },
  wallets: {
    applePay: 'never',
    googlePay: 'never',
  },
  fields: {
    billingDetails: {
      email: 'auto',
      address: {
        country: 'auto',
        postalCode: 'auto',
        state: 'auto',
      },
    },
  },
}
